import { PageLoadingIndicator } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'
import { Navigate } from 'react-router'

import { getCurrentPolicyVersion, QuoteStatus } from '../../../../../domain'
import { useApiErrorHandlingAsync } from '../../../../../hooks/auth'
import { ManagementConfig } from '../../../../../state/configuration'
import { usePrincipal } from '../../../../authentication'
import { AllowedPolicyAdjustmentPage } from './AllowedPolicyAdjustmentPage'
import { InvalidPolicyAdjustmentPage } from './InvalidPolicyAdjustmentPage'
import { ReferredPolicyAdjustmentPage } from './ReferredPolicyAdjustmentPage'

export interface PolicyAdjustmentResultPageProps {
  config?: ManagementConfig
  adjustmentId: string
  onRepeat: () => void
}

export const PolicyAdjustmentReviewPage: FunctionComponent<
  PolicyAdjustmentResultPageProps
> = ({ config, adjustmentId, onRepeat }) => {
  const { apiClient } = usePrincipal()

  const { result, loading } = useApiErrorHandlingAsync(apiClient.getPolicyAdjustment, [
    adjustmentId,
  ])

  if (loading) return <PageLoadingIndicator />
  if (!result || result.confirmed) return <Navigate to='..' />

  const updatedPolicyVersions = result.updatedPolicyVersions
  const currentQuote = getCurrentPolicyVersion(updatedPolicyVersions).quote

  const isCurrentVersionReferral = currentQuote.ratingStatus === QuoteStatus.REFERRAL
  const isAllQuote = updatedPolicyVersions.every(
    (policyVersion) => policyVersion.quote.ratingStatus === QuoteStatus.QUOTE,
  )

  if (isAllQuote) {
    return (
      <AllowedPolicyAdjustmentPage
        adjustment={result}
        config={config}
        onRepeat={onRepeat}
      />
    )
  } else if (isCurrentVersionReferral) {
    return <ReferredPolicyAdjustmentPage quote={currentQuote} onRepeat={onRepeat} />
  } else {
    return <InvalidPolicyAdjustmentPage />
  }
}
